import { render, staticRenderFns } from "./PreviewQuadiaLive.vue?vue&type=template&id=12dd986d&scoped=true&"
import script from "./PreviewQuadiaLive.vue?vue&type=script&lang=js&"
export * from "./PreviewQuadiaLive.vue?vue&type=script&lang=js&"
import style0 from "./PreviewQuadiaLive.vue?vue&type=style&index=0&id=12dd986d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dd986d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
